import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import api from '../../api/api'


// End Method
export const get_currencyIQD = createAsyncThunk(
  'dashboard/get_currencyIQD',
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get('/get-currencyIQD', {
        withCredentials: true,
      })
      //  console.log(data)
      return fulfillWithValue(data)
    } catch (error) {
      // console.log(error.response.data)
      return rejectWithValue(error.response.data)
    }
  }
)
// End Method

export const dashboardReducer = createSlice({
  name: 'dashboard',
  initialState: {
    recentOrders: [],
    errorMessage: '',
    successMessage: '',
    totalOrder: 0,
    pendingOrder: 0,
    deliveredOrder: 0,
    currencyIQD: 0,
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = ''
      state.successMessage = ''
    },
  },
  extraReducers: (builder) => {
    builder

     
      .addCase(get_currencyIQD.fulfilled, (state, { payload }) => {
        state.currencyIQD = payload.currencyIQD
      })
  },
})
export const { messageClear } = dashboardReducer.actions
export default dashboardReducer.reducer
